






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "name",
          "sort-desc": false,
        },
        content: {
          name: "Quản lý đối tác",
          urlEnabled: true,
          search: {},
          displayFields: {
            name: {
              text: "Tên",
              sortable: true,
              options: {
                to(_, item) {
                  return `/app/payment/partners/${item._id}/`;
                },
              },
            },
            description: {
              text: "Mô tả",
              sortable: true,
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            insert: {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("paymentPartners", "findAll", options, undefined, undefined, "viewProtectedPage3");
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("paymentPartners", "create", undefined, item, undefined, "viewProtectedPage3");
            },
            async update(item) {
              return await coreApiClient.call(
                "paymentPartners",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                },
                undefined,
                "viewProtectedPage3"
              );
            },
            async delete(item) {
              return await coreApiClient.call(
                "paymentPartners",
                "delete",
                {
                  id: item._id,
                },
                undefined,
                undefined,
                "viewProtectedPage3"
              );
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              isAirWalletPartner: {
                type: "boolean",
                attrs: {
                  label: "Đối tác AirWallet",
                },
              },
            },
            insertForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["name", "description", "isAirWalletPartner"],
              },
            },
            editForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["name", "description", "isAirWalletPartner"],
              },
            },
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
